import { render, staticRenderFns } from "./EditableStringList.vue?vue&type=template&id=47a086fd"
import script from "./EditableStringList.vue?vue&type=script&lang=js"
export * from "./EditableStringList.vue?vue&type=script&lang=js"
import style0 from "./EditableStringList.vue?vue&type=style&index=0&id=47a086fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports